import React from 'react';
import { View, Text } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { useLocale } from '../../contexts/LocaleContext';
import { useRTLStyles } from '../../hooks/useRTLStyles';
import { colors } from '../../theme';
import { formatReportDateTime, formatReportDuration } from '../../utils/reportFormat';
import { VisitTimingData, validVisitTime, visitDurationSeconds, visitTimeline } from '../../utils/visitTiming';

export const VisitTiming: React.FC<{ visit: VisitTimingData; timeline?: boolean }> = ({ visit, timeline = false }) => {
  const { t, locale } = useLocale();
  const rtl = useRTLStyles();
  const planned = [{ type: 'scheduled', at: visit.scheduledFor }, { type: 'due', at: visit.dueBy }].filter((r) => validVisitTime(r.at));
  const rows = timeline ? visitTimeline(visit) : [
    { type: 'created', at: visit.createdAt }, { type: 'assigned', at: visit.assignedAt },
    { type: 'started', at: visit.startedAt }, { type: 'completed', at: visit.endedAt }, { type: 'cancelled', at: visit.cancelledAt },
  ].filter((r) => validVisitTime(r.at));
  const seconds = visitDurationSeconds(visit);
  const units = { s: t('reports.duration.s'), m: t('reports.duration.m'), h: t('reports.duration.h'), d: t('reports.duration.d') };
  return <View style={{ gap: 5, marginTop: 8 }}>
    {[...planned, ...rows].map((row, i) => <View key={`${row.type}:${row.at}:${i}`} style={{ flexDirection: rtl.rowDirection, alignItems: 'flex-start', gap: 6 }}>
      <Ionicons name={row.type === 'scheduled' || row.type === 'due' ? 'calendar-outline' : 'time-outline'} size={13} color={colors.text.secondary as string} style={{ marginTop: 2 }} />
      <Text style={{ flex: 1, fontSize: 12, color: colors.text.secondary as string, textAlign: rtl.textStart }}>
        {t(`visits.timeline.${row.type}` as any)} · {formatReportDateTime(row.at, locale)}
        {'label' in row && row.label ? ` · ${row.label}` : ''}
      </Text>
    </View>)}
    {seconds !== undefined && <Text style={{ fontSize: 12, color: colors.text.secondary as string, textAlign: rtl.textStart }}>
      {t('reports.calls.duration')} · {formatReportDuration(seconds, units)}
    </Text>}
  </View>;
};
